import { render, staticRenderFns } from "./USStandardGeneralLedgerAccount.vue?vue&type=template&id=89e6fa54&"
import script from "./USStandardGeneralLedgerAccount.vue?vue&type=script&lang=js&"
export * from "./USStandardGeneralLedgerAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports